/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AwardCupIcon20Light = forwardRef('AwardCupIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 3a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v2.5a3.5 3.5 0 0 1-3.204 3.488A5.504 5.504 0 0 1 10 12.978V17h3.5a.5.5 0 0 1 0 1h-8a.5.5 0 0 1 0-1H9v-4.022a5.504 5.504 0 0 1-4.796-3.99A3.5 3.5 0 0 1 1 5.5V3Zm13.982 4.954A2.5 2.5 0 0 0 17 5.5V3h-2v4.5c0 .153-.006.304-.018.454ZM14 3H5v4.5a4.5 4.5 0 0 0 9 0V3ZM2 3h2v4.5c0 .153.006.304.018.454A2.5 2.5 0 0 1 2 5.5V3Z" })));
});
